import axios from "axios";

/**
 * RAG-65 — Réglages de la Plateforme Socoda.
 *   GET  admins/settings/plateforme-coefficient -> { coefficient }
 *   PUT  admins/settings/plateforme-coefficient -> { coefficient }
 * Le jeton admin est injecté automatiquement par l'intercepteur axios.
 */

function messageForStatus(error: any): string {
  const status = error?.response?.status;
  const apiMessage = error?.response?.data?.error ?? error?.response?.data?.message;
  switch (status) {
    case 403:
      return "Vous n'avez pas les droits pour modifier ce réglage.";
    case 422:
      return apiMessage || "Coefficient invalide (nombre strictement positif attendu).";
    default:
      return "Veuillez contacter un administrateur";
  }
}

/** Coefficient de prix de vente courant des produits plateforme (1 = neutre). */
function getCoefficient(): Promise<number> {
  return axios
    .get(`${process.env.REACT_APP_API_URL}admins/settings/plateforme-coefficient`)
    .then((response) => Number(response.data?.coefficient ?? 1));
}

/** Fixe le coefficient ; résout avec la valeur enregistrée côté serveur. */
function updateCoefficient(coefficient: number): Promise<number> {
  return new Promise((resolve, reject) => {
    axios
      .put(`${process.env.REACT_APP_API_URL}admins/settings/plateforme-coefficient`, {
        coefficient,
      })
      .then((response) => resolve(Number(response.data?.coefficient ?? coefficient)))
      .catch((error) => reject({ status: error?.response?.status, message: messageForStatus(error) }));
  });
}

export default {
  getCoefficient,
  updateCoefficient,
};
